import { LabwareDef } from '../../labware/types';

export const HARDCODED_BATCH_NUMBER = 1;
export const HARDCODED_DEFAULT_SLOT_NUMBER = 1;
export const PREVIEW_FAKE_LABWARE_DEF_URI = 'preview_fake_labware_def_uri';
export const NULL_LABWARE_TYPE = 'null_labware_type'; // https://github.com/automata-tech/prototype-frontend-editor/pull/244#issuecomment-2251444388

export const previewFakeLabwareDefinition: LabwareDef = {
  displayName: 'fake',
  namespace: 'fakeNamespace',
  loadName: 'fake',
  type: 'microplate',
  dimensions: {
    xDimension: 0,
    yDimension: 0,
    zDimension: 0,
  },
};

export const API_DATA_EXPORT_INPUT_ID = 'input_task';
export const LOCAL_DATA_EXPORT_INPUT_ID = 'data_key';
